import { View } from './view';

export const AboutUsPage = View;
